<template>
    <form id="contact-form-page">
        <div class="row">
            <div class="form-group col-md-6 col-sm-6">
                <label class="control-label" v-lang.name></label>
                <input  v-model="contacto.name" type="text" class="form-control" name="name" v-bind:placeholder="tr('enter_name')">
            </div>
            <div class="form-group col-md-6 col-sm-6">
                <label class="control-label" v-lang.phone></label>
                <input v-model="contacto.phone" type="text" class="form-control" name="phone" v-bind:placeholder="tr('enter_phone')">
            </div>
            <div class="form-group col-md-6 col-sm-6">
                <label class="control-label" v-lang.email></label>
                <input v-model="contacto.email" type="email" class="form-control" name="email" v-bind:placeholder="tr('enter_email')">
            </div>
            <div class="form-group col-md-6 col-sm-6">
                <label class="control-label" v-lang.subject></label>
                <input v-model="contacto.subject" type="text" class="form-control" name="subject" v-bind:placeholder="tr('enter_subject')">
            </div>
            <div class="form-group col-md-12">
                <label class="control-label" v-lang.message></label>
                <textarea v-model="contacto.message" class="form-control" name="message" v-bind:placeholder="tr('enter_message')"></textarea>
            </div>
            <div class="form-group col-md-12">
                <button v-on:click.prevent.stop="send" v-bind:class="{ 'disabled' : !valid }" :disabled="!valid" type="submit" class="button  btn_blue mt40 upper pull-right">
                    <i class="fa fa-paper-plane-o" aria-hidden="true"></i> <span v-lang.send_message></span>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import options from '../../config/app';
    import Form from './index';
    export default {
        props : ['contacto'],
        created : Form.created,
        beforeDestroy : Form.beforeDestroy,
        methods : Form.methods,
        computed : Form.computed
    };
</script>

<style lang="scss">
    button
    {
        &.disabled
        {
            opacity: 0.5 !important;
            cursor: not-allowed;
        }
    }
</style>


// WEBPACK FOOTER //
// Extend.vue?2485cf60